import React from 'react'
import './demovideo.css';

import top from '../assets/demo/top.png';
import bottom from '../assets/demo/bottom.png';

import top2 from '../assets/demo/top2.png';
import bottom2 from '../assets/demo/bottom2.png';

import Logo from '../assets/nav/logo.png';


import {BsYoutube} from 'react-icons/bs';

const demovideo = () => {
    return (
        <>
            <div className="hero-demo">
                <div className="top">
                    <img src={top2} alt="" />
                </div>
                <div className="demo-heading">
                    <h1>Download The App To Play Games & Earn Coins</h1>
                </div>
                <div className="container video-content">
                    <div className="hero-video">
                        <div className="demo-video">
                            {/* <img src={Logo} alt="" />
                            <BsYoutube size="2rem"/> */}
                        </div>
                    </div>
                    <div className="hero-guide">
                        <h2> Easy Steps To Earn Money</h2>
                        <ol>
                            <li>Install The RewardPro App</li>
                            <li>Create An Account And Login</li>
                            <li>Start Playing Games And Earn Rewards.</li>
                        </ol>
                    </div>
                </div>
                <div className="bottom">
                    <img src={bottom2} alt=""/>
                </div>
                {/* <div className="demo-para">
                    <p>Easy steps to earn money</p>
                </div> */}
            </div>
        </>
    )
}

export default demovideo
